var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#FAEAEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8181 20.1734L21.1247 19.98C20.9256 19.9567 20.7238 19.9787 20.5344 20.0445C20.3451 20.1103 20.1731 20.2182 20.0314 20.36L18.8047 21.5867C16.9122 20.6242 15.3739 19.0859 14.4114 17.1934L15.6447 15.96C15.9314 15.6734 16.0714 15.2734 16.0247 14.8667L15.8314 13.1867C15.7936 12.8615 15.6375 12.5615 15.3929 12.3439C15.1483 12.1264 14.8321 12.0063 14.5047 12.0067H13.3514C12.5981 12.0067 11.9714 12.6334 12.0181 13.3867C12.3714 19.08 16.9247 23.6267 22.6114 23.98C23.3647 24.0267 23.9914 23.4 23.9914 22.6467V21.4934C23.9981 20.82 23.4914 20.2534 22.8181 20.1734Z",
    fill: "#DB5959"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.b6f788f82c2974f9a1accfc4572c1928.svg";
export { ForwardRef as ReactComponent };